<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-israel-map-box">
  <!-- Artboard: xs -->
  <div
    id="g-israel-map-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.64705882352941;"
  >
    <div
      id="g-israel-map-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/israel-map-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:2.4063%;margin-top:-9.3px;left:1.2277%;width:88px;"
    >
      <p class="g-pstyle0">Mediterranean</p>
      <p class="g-pstyle0">Sea</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:4.3052%;margin-top:-7px;left:30.3274%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle1">Syria</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:8.3248%;margin-top:-2.5px;left:15.8647%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle2">Tel-Aviv</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:11.5601%;margin-top:-7px;left:25.2859%;width:65px;"
    >
      <p class="g-pstyle3">Jordan</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:15.452%;margin-top:-2.8px;left:13.5899%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle4">ISRAEL</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:19.5094%;margin-top:-12.5px;left:86.7676%;width:64px;"
    >
      <p class="g-pstyle5">Iranian</p>
      <p class="g-pstyle5">airstrike</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:22.8542%;margin-top:-13.6px;left:32.6071%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle1">SAUDI</p>
      <p class="g-pstyle1">ARABIA</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:21.8786%;margin-top:-7.6px;right:20.0355%;width:61px;"
    >
      <p class="g-pstyle6">Tamra</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:21.9523%;margin-top:-7px;left:5.8865%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle1">EGYPT</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:27.761%;margin-top:-21.6px;right:34.1852%;width:133px;"
    >
      <p class="g-pstyle6">Haifa</p>
      <p class="g-pstyle7">Oil refinery</p>
      <p class="g-pstyle7">sustained damage.</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-anno g-aiAbs"
      style="bottom:24.9441%;left:2.7136%;width:54.2424%;"
    >
      <p class="g-pstyle8">Bat Yam</p>
      <p>An Iranian ballistic missile</p>
      <p>struck a residential building,</p>
      <p>killing four civillians.</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:79.3296%;margin-top:-7.6px;left:31.2211%;width:131px;"
    >
      <p class="g-pstyle9">Ben Gurion Airport</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:86.1924%;margin-top:-7.6px;left:32.4701%;width:72px;"
    >
      <p class="g-pstyle10">Rehovot</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.3722%;margin-top:-7.5px;left:7.2807%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle11">10 km</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-israel-map-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.82258064516129;"
  >
    <div
      id="g-israel-map-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/israel-map-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:2.4652%;margin-top:-11.3px;left:1.0604%;width:93px;"
    >
      <p class="g-pstyle0">Mediterranean</p>
      <p class="g-pstyle0">Sea</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:4.2739%;margin-top:-7.5px;left:24.1424%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle1">Syria</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:8.2255%;margin-top:-3px;left:12.6205%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle2">Tel-Aviv</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:11.5319%;margin-top:-7.5px;left:20.1273%;width:69px;"
    >
      <p class="g-pstyle3">Jordan</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:15.3223%;margin-top:-4px;left:10.8146%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle4">ISRAEL</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:18.7228%;margin-top:-9.1px;left:73.1468%;width:116px;"
    >
      <p class="g-pstyle5">Iranian airstrike</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:22.0158%;margin-top:-7.5px;left:4.7402%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle1">EGYPT</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:22.3518%;margin-top:-8.6px;left:71.0472%;width:61px;"
    >
      <p class="g-pstyle6">Tamra</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:23.661%;margin-top:-14.7px;left:25.9656%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle1">SAUDI</p>
      <p class="g-pstyle1">ARABIA</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:27.8128%;margin-top:-24.4px;right:42.9454%;width:133px;"
    >
      <p class="g-pstyle7">Haifa</p>
      <p class="g-pstyle8">Oil refinery</p>
      <p class="g-pstyle8">sustained damage.</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-anno g-aiAbs"
      style="bottom:23.9066%;left:7.8431%;width:35.098%;"
    >
      <p class="g-pstyle9">Bat Yam</p>
      <p>An Iranian ballistic missile</p>
      <p>struck a residential building,</p>
      <p>killing four civillians.</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:81.0453%;margin-top:-17.5px;left:29.6346%;width:87px;"
    >
      <p class="g-pstyle10">Ben Gurion</p>
      <p class="g-pstyle10">Airport</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:86.8679%;margin-top:-8.6px;left:30.6244%;width:72px;"
    >
      <p class="g-pstyle6">Rehovot</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.9217%;margin-top:-9.5px;left:1.568%;width:59px;"
    >
      <p class="g-pstyle11">10 km</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-israel-map-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.11864406779661;"
  >
    <div
      id="g-israel-map-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/israel-map-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:2.2878%;margin-top:-10.5px;left:0.6694%;width:93px;"
    >
      <p class="g-pstyle0">Mediterranean</p>
      <p class="g-pstyle0">Sea</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:4.1522%;margin-top:-7.5px;left:17.5407%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle1">Syria</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:8.1353%;margin-top:-3px;left:9.1189%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle2">Tel-Aviv</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:11.4403%;margin-top:-7.5px;left:14.6057%;width:69px;"
    >
      <p class="g-pstyle3">Jordan</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:15.1692%;margin-top:-3.5px;left:7.7993%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle4">ISRAEL</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:18.9968%;margin-top:-9.1px;left:63.5849%;width:116px;"
    >
      <p class="g-pstyle5">Iranian airstrike</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:21.7793%;margin-top:-7.5px;left:3.3598%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle1">EGYPT</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:22.3866%;margin-top:-8.1px;left:61.9513%;width:61px;"
    >
      <p class="g-pstyle6">Tamra</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:23.5081%;margin-top:-14.7px;left:18.8744%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle1">SAUDI</p>
      <p class="g-pstyle1">ARABIA</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:27.9798%;margin-top:-23.1px;right:48.2768%;width:133px;"
    >
      <p class="g-pstyle7">Haifa</p>
      <p class="g-pstyle8">Oil refinery</p>
      <p class="g-pstyle8">sustained damage.</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:73.3329%;margin-top:-7.7px;left:28.6094%;margin-left:-49px;width:98px;"
    >
      <p class="g-pstyle9">Tel-Aviv</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:81.1154%;margin-top:-30.6px;right:72.079%;width:187px;"
    >
      <p class="g-pstyle7">Bat Yam</p>
      <p class="g-pstyle8">An Iranian ballistic missile</p>
      <p class="g-pstyle8">struck a residential building,</p>
      <p class="g-pstyle8">killing four civillians.</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:80.5929%;margin-top:-12.5px;left:31.6824%;width:78px;"
    >
      <p class="g-pstyle10">Ben Gurion</p>
      <p class="g-pstyle10">Airport</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:86.6239%;margin-top:-8.1px;left:32.4059%;width:72px;"
    >
      <p class="g-pstyle6">Rehovot</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.7595%;margin-top:-9.1px;left:3.2858%;width:57px;"
    >
      <p class="g-pstyle11">10 km</p>
    </div>
  </div>
</div>

<!-- End ai2html - 2025-06-17 12:16 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-17 12:16 -->
<!-- ai file: israel-map.ai -->
<style lang="scss">
  #g-israel-map-box,
  #g-israel-map-box .g-artboard {
    margin: 0 auto;
  }
  #g-israel-map-box p {
    margin: 0;
  }
  #g-israel-map-box .g-aiAbs {
    position: absolute;
  }
  #g-israel-map-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-israel-map-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-israel-map-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-israel-map-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-israel-map-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) {
      #g-israel-map-md {
        display: block !important;
      }
    }
  }
  #g-israel-map-xs {
    position: relative;
    overflow: hidden;
  }
  #g-israel-map-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 15px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-israel-map-xs .g-pstyle0 {
    font-style: italic;
    line-height: 9px;
    height: 9px;
    letter-spacing: 0.005em;
    font-size: 11px;
    color: rgb(150, 180, 184);
  }
  #g-israel-map-xs .g-pstyle1 {
    line-height: 13px;
    height: 13px;
    letter-spacing: 0.05em;
    font-size: 11px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-israel-map-xs .g-pstyle2 {
    font-weight: 500;
    line-height: 4px;
    height: 4px;
    font-size: 11px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-israel-map-xs .g-pstyle3 {
    line-height: 13px;
    height: 13px;
    letter-spacing: 0.05em;
    font-size: 11px;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-israel-map-xs .g-pstyle4 {
    font-weight: 500;
    line-height: 5px;
    height: 5px;
    letter-spacing: 0.2em;
    font-size: 10px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(41, 41, 41);
  }
  #g-israel-map-xs .g-pstyle5 {
    font-weight: 500;
    line-height: 12px;
    height: 12px;
    font-size: 12px;
    color: rgb(0, 0, 0);
  }
  #g-israel-map-xs .g-pstyle6 {
    font-weight: 700;
    line-height: 14px;
    height: 14px;
    text-align: right;
  }
  #g-israel-map-xs .g-pstyle7 {
    line-height: 14px;
    height: 14px;
    text-align: right;
  }
  #g-israel-map-xs .g-pstyle8 {
    font-weight: 700;
    line-height: 16px;
  }
  #g-israel-map-xs .g-pstyle9 {
    line-height: 14px;
    height: 14px;
    color: rgb(0, 0, 0);
  }
  #g-israel-map-xs .g-pstyle10 {
    font-weight: 700;
    line-height: 14px;
    height: 14px;
  }
  #g-israel-map-xs .g-pstyle11 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    text-align: center;
  }
  #g-israel-map-sm {
    position: relative;
    overflow: hidden;
  }
  #g-israel-map-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 15px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-israel-map-sm .g-pstyle0 {
    font-style: italic;
    line-height: 11px;
    height: 11px;
    letter-spacing: 0.005em;
    font-size: 12px;
    color: rgb(150, 180, 184);
  }
  #g-israel-map-sm .g-pstyle1 {
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.05em;
    font-size: 12px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-israel-map-sm .g-pstyle2 {
    font-weight: 500;
    line-height: 5px;
    height: 5px;
    font-size: 12px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-israel-map-sm .g-pstyle3 {
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.05em;
    font-size: 12px;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-israel-map-sm .g-pstyle4 {
    font-weight: 500;
    line-height: 7px;
    height: 7px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(41, 41, 41);
  }
  #g-israel-map-sm .g-pstyle5 {
    font-weight: 500;
    line-height: 17px;
    height: 17px;
    color: rgb(0, 0, 0);
  }
  #g-israel-map-sm .g-pstyle6 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
  }
  #g-israel-map-sm .g-pstyle7 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    text-align: right;
  }
  #g-israel-map-sm .g-pstyle8 {
    line-height: 16px;
    height: 16px;
    text-align: right;
  }
  #g-israel-map-sm .g-pstyle9 {
    font-weight: 700;
    line-height: 16px;
  }
  #g-israel-map-sm .g-pstyle10 {
    line-height: 17px;
    height: 17px;
    color: rgb(0, 0, 0);
  }
  #g-israel-map-sm .g-pstyle11 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
  }
  #g-israel-map-md {
    position: relative;
    overflow: hidden;
  }
  #g-israel-map-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 15px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-israel-map-md .g-pstyle0 {
    font-style: italic;
    line-height: 10px;
    height: 10px;
    letter-spacing: 0.005em;
    font-size: 12px;
    color: rgb(150, 180, 184);
  }
  #g-israel-map-md .g-pstyle1 {
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.05em;
    font-size: 12px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-israel-map-md .g-pstyle2 {
    font-weight: 500;
    line-height: 5px;
    height: 5px;
    font-size: 12px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-israel-map-md .g-pstyle3 {
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.05em;
    font-size: 12px;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-israel-map-md .g-pstyle4 {
    font-weight: 500;
    line-height: 6px;
    height: 6px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(41, 41, 41);
  }
  #g-israel-map-md .g-pstyle5 {
    font-weight: 500;
    line-height: 17px;
    height: 17px;
    color: rgb(0, 0, 0);
  }
  #g-israel-map-md .g-pstyle6 {
    font-weight: 700;
    height: 15px;
  }
  #g-israel-map-md .g-pstyle7 {
    font-weight: 700;
    height: 15px;
    text-align: right;
  }
  #g-israel-map-md .g-pstyle8 {
    height: 15px;
    text-align: right;
  }
  #g-israel-map-md .g-pstyle9 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 16px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-israel-map-md .g-pstyle10 {
    line-height: 12px;
    height: 12px;
    font-size: 12px;
    color: rgb(0, 0, 0);
  }
  #g-israel-map-md .g-pstyle11 {
    font-weight: 500;
    line-height: 17px;
    height: 17px;
  }

  /* Custom CSS */
  .g-text {
  }
</style>
